import DiagramDataStore from '../../models/DiagramDataStore'

const saveDatastore = (dataStore: DiagramDataStore): Promise<void> => {
  window.localStorage.setItem('diagrams', JSON.stringify(dataStore))
  return Promise.resolve()
}

export default saveDatastore
